import React, { useEffect } from 'react'
import Navbar from '../../Components/Navbar'
import Copyrights from '../../Components/Copyrights'
import styles from './style.module.scss'
import { Helmet } from 'react-helmet'
import { HeaderImg } from '../../Components/Header'
import headerImg from '../../Assets/headerImgs/abd.jpg'
import visionMissionImg from '../../Assets/headerImgs/vision-mission.jpg'
import historyImg from '../../Assets/headerImgs/aboutus1.jpg'
import historyImg2 from '../../Assets/headerImgs/aboutus2.jpg'
import Aos from 'aos'
import 'aos/dist/aos.css';

const AboutUsPage = () => {

  useEffect(() => {
    Aos.init();
  }, [])

  return (
    <div className={styles.container}>
      <Helmet>
        <title>About Us | Wedage & Company</title>
      </Helmet>
      <Navbar active="about-us" />
      <HeaderImg img={headerImg} alt="headerImg" />

      <div className={styles.aboutUsCont}>
        <div className={styles.visionMissionCont}>
          {/* <div className={styles.visionMissionText}> */}
          <img src={visionMissionImg} alt="visionMissionImg" data-aos="fade-up" data-aos-duration="1000"></img>
          <h1>Vision</h1>
          <p>Our collective vision is to be the most prominent and trusted brand of the refrigerated transportation industry in Sri Lanka.</p>
          <br />
          <h1>Mission</h1>
          <p>Our mission is to provide the most reliable and flexible refrigerated trucking solution tailor made for each individual customer, by continuously upgrading our technology and striving to provide better solutions to our valued customer base.</p>
          {/* </div> */}
        </div>
        <div className={styles.historyCont}>
          <img src={historyImg} alt="historyImg" data-aos="fade-up" data-aos-duration="1000"></img>
          {/* <div className={styles.historyText}> */}
          <h1>History</h1>
          <p>The company had its humble beginning in the year of 1997 with just two refrigerated trucks.
            <br />
            <br />
            Our services have since maintained 20 years of experience in the industry with “exceptional quality of service” being our primary motive.
            We have earned the trust of our customers as the integral medium that provides a reliable and quality service of transporting perishable goods as the number one refrigerated transportation company in Sri Lanka.
            <br />
            <br />

            In order to transport a wide range of perishable goods, our company utilizes state-of-the-art trucks equipped with the latest in temperature control technology which are calibrated under SLSI approved methods.
            The company has a great team with varied skills including drivers and helpers that are well trained.
            We believe that we are the most capable refrigerated transportation service provider in Sri Lanka. Wedage & Company offers the right service for your business when it comes to the on-time delivery of your perishable goods.</p>
          <img src={historyImg2} alt='aboutUs img 2' data-aos="fade-up" data-aos-duration="1000"></img>
          {/* </div> */}
        </div>
        {/* <div className={styles.historyCont}>
          <img src={historyImg} alt="historyImg" />
          <div className={styles.historyText}>
            <h1>History</h1>
            <p>
              The company had its humble beginning in the year of 1997 with just two refrigerated trucks.
            </p>
            <p>
              Our services have since maintained 20 years of experience in the industry with “exceptional quality of service” being our primary motive.
              We have earned the trust of our customers as the integral medium that provides a reliable and quality service of transporting perishable goods as the number one refrigerated transportation company in Sri Lanka.
            </p>
            <p>
              In order to transport a wide range of perishable goods, our company utilizes state-of-the-art trucks equipped with the latest in temperature control technology which are calibrated under SLSI-approved methods.
              The company has a great team with varied skills including drivers and helpers that are well trained.
            </p>
            <p>
              We believe that we are the most capable refrigerated transportation service provider in Sri Lanka. Wedage & Company offers the right service for your business when it comes to the on-time delivery of your perishable goods.
            </p>
          </div>
        </div> */}

      </div>
      <Copyrights />

    </div>
  )
}

export default AboutUsPage